export default "__VITE_ASSET__2a40bc14__"